/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

/**
 * Component that is used for rendering advertisements
 */
function Advertisement({ position, className, isActive, isCentered }) {
    const asideClass = classNames(
        'ui-advertising__container',
        `js-advertising__placeholder${position} ${className}`
    );
    const dataTestSelector = `block-advertising_position${position}`;
    const styleObject = isCentered ? { flexDirection: 'column' } : {};

    return (
        isActive ?
            <aside
                className={asideClass}
                data-test-selector={dataTestSelector}
                style={styleObject}
            /> :
            null
    );
}

Advertisement.propTypes = {
    /**
     * Advertisement position
     * Full list of available positions you can find there:
     * https://docs.google.com/spreadsheets/d/1A3s9YjyVhmBcrh5kMl8i2P3RJEyAcUhmwwthISf4gl8/edit#gid=834985875
     */
    position: PropTypes.number.isRequired,
    /**
     * Advertisement className
     * Additional css-classes, applied to the component
     */
    className: PropTypes.string,
    /**
     * Advertisement isActive
     * Define, if Advertisement block should be shown
     */
    isActive: PropTypes.bool.isRequired,
    /**
     * Advertisement isActive
     * Define, if Advertisement block should be centered
     */
    isCentered: PropTypes.bool,
};

Advertisement.defaultProps = {
    className: '',
    isCentered: false,
};

const mapStateToProps = ({ advertisement }, { position }) => ({
    isActive: !!advertisement.find(ad => ad.position === position && ad.isActive)
});

const ConnectedAdvertisement = connect(mapStateToProps)(Advertisement);

export {
    Advertisement,
    ConnectedAdvertisement as default
};



// WEBPACK FOOTER //
// ./src/js/Advertisement/Advertisement.js